import React from 'react';

const PlaceholderCover = () => (
  <div className="h-full w-full bg-gradient-to-br from-brand/20 via-[#F472B6]/10 to-brand/5 flex items-center justify-center">
    <div className="text-center px-6">
      <p className="text-sm font-semibold text-brand tracking-wide uppercase">
        Blog
      </p>
      <p className="text-xs text-gray-500 mt-1">
        Muy pronto imagen para esta entrada
      </p>
    </div>
  </div>
);

const truncate = (text, limit = 160) => {
  if (!text) return '';
  if (text.length <= limit) return text;
  return `${text.slice(0, limit).trim()}…`;
};

const BlogCard = ({
  post,
  category,
  onClick,
  showExcerpt = true,
  readingTime,
  className = '',
}) => {
  if (!post) return null;
  const chipLabel = category?.name || 'Sin categoría';
  const excerpt = showExcerpt ? truncate(post.excerpt || '') : null;

  return (
    <article
      className={`group flex flex-col bg-white rounded-3xl border border-gray-100 shadow-[0_25px_45px_rgba(15,23,42,0.08)] hover:-translate-y-1 transition-all duration-300 overflow-hidden cursor-pointer ${className}`}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick?.();
        }
      }}
    >
      <div className="relative aspect-[4/3] overflow-hidden">
        {post.cover_image_url ? (
          <img
            src={post.cover_image_url}
            alt={post.title}
            className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
            loading="lazy"
          />
        ) : (
          <PlaceholderCover />
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-black/5 to-transparent" />
        <span className="absolute top-4 left-4 inline-flex items-center rounded-full bg-white/90 px-3 py-1 text-xs font-semibold text-gray-700">
          {chipLabel}
        </span>
      </div>
      <div className="flex flex-col flex-1 p-6">
        {readingTime ? (
          <p className="text-xs font-semibold text-gray-500 uppercase tracking-[0.3em] mb-2">
            {`${readingTime} min`}
          </p>
        ) : null}
        <h3 className="text-2xl font-semibold text-gray-900 leading-snug mb-3">
          {post.title}
        </h3>
        {excerpt && (
          <p className="text-gray-600 text-base leading-relaxed flex-1 mb-4">
            {excerpt}
          </p>
        )}
        <div className="flex items-center text-brand font-semibold gap-2">
          Leer artículo
          <span aria-hidden="true">→</span>
        </div>
      </div>
    </article>
  );
};

export default BlogCard;
